import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
        paddingBottom: theme.spacing(),
        borderBottom: `4px solid ${theme.palette.secondary.light}`
    },
    title: {
        marginBottom: theme.spacing(0),
        paddingBottom: theme.spacing(0)
    }
}));

export default function PageTitle(props) {
    const {
        title,
        children,
        className
    } = props;
    const classes = useStyles();

    return (
        <div className={clsx(classes.root, !!className && className)}>
            {title && (
                <Typography variant="h5" gutterBottom className={classes.title}>
                    {title}
                </Typography>
            )}
            {children}
        </div>
    );
};

PageTitle.propTypes = {
    title: PropTypes.string,
    className: PropTypes.string
};